// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flex-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 2rem;
    font-size: medium;
    font-weight: bold;
    margin: 0.5rem 0;
}

.flex-container div {
    padding: 10px;
    text-align: left;
    margin-top:12px;
}

.dropdown {
    margin-left: -4px;
    padding: 4px;
    width: 105%;
    margin-top: -2rem;
    border-radius: 4px;
    border: 1px solid #ccc;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    font-weight: normal;
}

.mt15 {
    margin-top: 15px;
}

.input-fields-so {
    margin-left: -3px;
    padding: 4px;
    width: 101%;
    margin-top: -2rem;
    border-radius: 4px;
    border: 1px solid #ccc;
    font-size: medium;
    box-sizing: border-box;
    vertical-align: middle;
    font-weight: normal;
    color: black;
}



.text-light-text {
    --tw-text-opacity: 1;
    color: rgb(90 105 123 / var(--tw-text-opacity));
}

.input-field::placeholder {
    color: #808080;
    font-style: italic;
    font-size: medium;
    opacity: 0.8;
    font-weight: normal;
}

.mt-1rem {
    margin-top: -1rem;
}

.input-fields.mafield {
    margin-left: -3px;
    padding: 4px;
    width: 87%;
    margin-top: -2rem;
    border-radius: 4px;
    border: 1px solid #ccc;
    font-size: medium;
    box-sizing: border-box;
    vertical-align: middle;
    font-weight: normal;
    color: black;
}

.flex-container.right-align {
    justify-content: flex-end;
}

.flex-container-button {
    display: flex;
    justify-content: space-between;
    /* Default alignment for elements */
    align-items: center;
    margin: 1rem 0;
}

.button-white-bg {
    background-color: white;
    color: #007BFF;
    border: 2px solid #007BFF;
    border-radius: 2px;
    padding: 8px 16px;
    cursor: pointer;
    font-size: medium;
    transition: background-color 0.3s, color 0.3s;
    min-width: 166px;
}

.button-clear-bg {
    min-width: 166px;
}

.flex-container-button.right-align {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    flex-wrap: nowrap;
}

.flex-container-button.right-align>div {
    display: flex;
    gap: 10px;
    flex-wrap: nowrap;
}

.custom-popup-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.3);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-popup {
  background: #fff;
  padding: 2rem;
  border-radius: 8px;
  min-width: 300px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.2);
}

.pipeline-banner {
  position: sticky;
   top: 0; left: 0; right: 0; bottom: 0;
  z-index: 999;
  padding: 12px 20px;
  text-align: center;
  font-weight: bold;
  border-bottom: 2px solid #ccc;
}

.pipeline-success {
  background-color: #d4edda;
}

.pipeline-error {
  background-color: #f8d7da;
}

.pipeline-warning {
  background-color: #fff3cd;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/tab/InterfacesTab/InterfacesTab.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kCAAkC;IAClC,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;AAChB;;;;AAIA;IACI,oBAAoB;IACpB,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mCAAmC;IACnC,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,6CAA6C;IAC7C,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,iBAAiB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;GACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACrC,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".flex-container {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    gap: 2rem;\n    font-size: medium;\n    font-weight: bold;\n    margin: 0.5rem 0;\n}\n\n.flex-container div {\n    padding: 10px;\n    text-align: left;\n    margin-top:12px;\n}\n\n.dropdown {\n    margin-left: -4px;\n    padding: 4px;\n    width: 105%;\n    margin-top: -2rem;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    font-weight: normal;\n}\n\n.mt15 {\n    margin-top: 15px;\n}\n\n.input-fields-so {\n    margin-left: -3px;\n    padding: 4px;\n    width: 101%;\n    margin-top: -2rem;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n    font-size: medium;\n    box-sizing: border-box;\n    vertical-align: middle;\n    font-weight: normal;\n    color: black;\n}\n\n\n\n.text-light-text {\n    --tw-text-opacity: 1;\n    color: rgb(90 105 123 / var(--tw-text-opacity));\n}\n\n.input-field::placeholder {\n    color: #808080;\n    font-style: italic;\n    font-size: medium;\n    opacity: 0.8;\n    font-weight: normal;\n}\n\n.mt-1rem {\n    margin-top: -1rem;\n}\n\n.input-fields.mafield {\n    margin-left: -3px;\n    padding: 4px;\n    width: 87%;\n    margin-top: -2rem;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n    font-size: medium;\n    box-sizing: border-box;\n    vertical-align: middle;\n    font-weight: normal;\n    color: black;\n}\n\n.flex-container.right-align {\n    justify-content: flex-end;\n}\n\n.flex-container-button {\n    display: flex;\n    justify-content: space-between;\n    /* Default alignment for elements */\n    align-items: center;\n    margin: 1rem 0;\n}\n\n.button-white-bg {\n    background-color: white;\n    color: #007BFF;\n    border: 2px solid #007BFF;\n    border-radius: 2px;\n    padding: 8px 16px;\n    cursor: pointer;\n    font-size: medium;\n    transition: background-color 0.3s, color 0.3s;\n    min-width: 166px;\n}\n\n.button-clear-bg {\n    min-width: 166px;\n}\n\n.flex-container-button.right-align {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: nowrap;\n}\n\n.flex-container-button.right-align>div {\n    display: flex;\n    gap: 10px;\n    flex-wrap: nowrap;\n}\n\n.custom-popup-overlay {\n  position: fixed;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: rgba(0,0,0,0.3);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.custom-popup {\n  background: #fff;\n  padding: 2rem;\n  border-radius: 8px;\n  min-width: 300px;\n  box-shadow: 0 2px 16px rgba(0,0,0,0.2);\n}\n\n.pipeline-banner {\n  position: sticky;\n   top: 0; left: 0; right: 0; bottom: 0;\n  z-index: 999;\n  padding: 12px 20px;\n  text-align: center;\n  font-weight: bold;\n  border-bottom: 2px solid #ccc;\n}\n\n.pipeline-success {\n  background-color: #d4edda;\n}\n\n.pipeline-error {\n  background-color: #f8d7da;\n}\n\n.pipeline-warning {\n  background-color: #fff3cd;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
